'use client';

import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { FOLD_EXIT } from './motion';

interface SectionPresenceProps {
  /** Still loading, or something to show. */
  show: boolean;
  children: ReactNode;
}

/**
 * A section that comes back empty — or fails — after its skeleton folds away,
 * instead of yanking every section under it up in one frame.
 */
export function SectionPresence({ show, children }: SectionPresenceProps) {
  return (
    <AnimatePresence initial={false}>
      {show ? (
        <motion.div key="section" exit={FOLD_EXIT} className="overflow-hidden">
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
